import { getIntersectionRoot } from '@theme/scroll-container';

class SybilPdpStat extends HTMLElement {
  #observer;
  #raf;

  connectedCallback() {
    if (this.abortController) return;
    this.abortController = new AbortController();

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduced.matches) {
      this.#setDisplay(this.#target);
      return;
    }

    this.#observer = new IntersectionObserver(this.#onIntersect, {
      root: getIntersectionRoot(),
      threshold: 0.3,
    });
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = undefined;
    this.#observer?.disconnect();
    if (this.#raf) cancelAnimationFrame(this.#raf);
  }

  get #target() {
    return Number(this.dataset.target || '0');
  }

  get #decimals() {
    return Number(this.dataset.decimals || '0');
  }

  get #valueEl() {
    return this.querySelector('[data-sybil-stat-value]');
  }

  #onIntersect = (entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    this.#observer?.disconnect();
    this.#animate();
  };

  #animate() {
    const duration = 1600;
    const start = performance.now();
    const target = this.#target;
    const step = (now) => {
      const progress = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      this.#setDisplay(target * eased);
      if (progress < 1) {
        this.#raf = requestAnimationFrame(step);
      }
    };
    this.#raf = requestAnimationFrame(step);
  }

  #setDisplay(value) {
    const el = this.#valueEl;
    if (!el) return;
    const decimals = this.#decimals;
    el.textContent = decimals > 0 ? value.toFixed(decimals) : String(Math.round(value));
  }
}

if (!customElements.get('sybil-pdp-stat')) {
  customElements.define('sybil-pdp-stat', SybilPdpStat);
}
